import { render, staticRenderFns } from "./prolongList.vue?vue&type=template&id=4bc70ccc&"
import script from "./prolongList.vue?vue&type=script&lang=js&"
export * from "./prolongList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports